import { z } from 'zod';

// An internal timer, not a domain fact: asks the communications module to read
// one logged e-mail's delivery status from the provider (IMM-1076.3).
export const EmailDeliveryCheckDuePayloadSchema = z.object({
  entryId: z.uuid(),
  attempt: z.number().int().min(1).max(6),
  sentAt: z.iso.datetime(),
});
export type EmailDeliveryCheckDuePayload = z.infer<typeof EmailDeliveryCheckDuePayloadSchema>;
